import ruleCommandReducer from "./reducers";

export default ruleCommandReducer;